import { httpRequests } from '../agent';
import { API_AUTH_LOGIN_ENDPOINT } from '../shared/constants';

// Authentication
export const Auth = {
  login: (username, password, providerId, version) =>
    httpRequests.post(`${API_AUTH_LOGIN_ENDPOINT}`, {
      username,
      password,
      providerId,
      uiVersion: version,
    }),
};

//
